<template>
    <header class="nav">
        <b-navbar active="false">
            <template slot="brand">
                <b-navbar-item tag="router-link" :to="{ path: '/' }">
                    <img src="../assets/deaf.png" alt="ABC">
                </b-navbar-item>
            </template>
            <template slot="start">
            </template>
            <template slot="end">
            </template>
        </b-navbar>
    </header>
</template>

<script>
  export default {
    name: 'Navigation',
  }
</script>

<style>
.navbar-item img {
    height: 60px;
    width: 60px;
    max-height: 60px !important;
}

.navbar-burger {
    display: none !important;
}

.navbar {
    background-color: #8566aa !important;
}

</style>
